module.exports = __webpack_public_path__ + "img/revers.6535d469.svg";